import { Link } from 'react-router-dom'
import { AlertTriangle } from 'lucide-react'

import { useHandoffAlertCount } from '@/hooks/useHandoffAlertCount'

/**
 * Persistent, always-visible banner (rendered in `AdminLayout`, above every
 * page) warning the team about conversations waiting for a human — 2026-07-16
 * incident follow-up. Before this, `human_handoff` was only visible as a
 * status badge inside `/conversations`, which nobody notices unless already
 * browsing that page. Polls every 30s via `useHandoffAlertCount`; renders
 * nothing when the count is zero.
 */
export function HandoffAlertBanner(): React.ReactElement | null {
  const { count } = useHandoffAlertCount()

  if (count === 0) return null

  const message =
    count === 1
      ? '1 conversa aguardando atendimento humano'
      : `${count} conversas aguardando atendimento humano`

  return (
    <Link
      to="/conversations?status=human_handoff"
      data-testid="handoff-alert-banner"
      className="flex items-center gap-2 border-b border-amber-300 bg-amber-50 px-4 py-2 text-sm font-medium text-amber-900 transition-colors hover:bg-amber-100 dark:border-amber-900 dark:bg-amber-950 dark:text-amber-200 dark:hover:bg-amber-900"
    >
      <AlertTriangle className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span>{message} — clique para ver</span>
    </Link>
  )
}
